import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { UIIcon, UITableBaseColumn } from '@shared/ui';
import { DashboardOperatorLoadStatisticModel } from '../../models';

@Component({
  selector: 'aggregator-dashboard-parking-load-difference',
  templateUrl: './parking-load-difference.component.html',
  styleUrl: './parking-load-difference.component.scss',
  standalone: true,
  imports: [CommonModule, UIIcon],
})
export class DashboardParkingLoadDifferenceComponent extends UITableBaseColumn {
  get averageLoad(): DashboardOperatorLoadStatisticModel['averageLoad'] | undefined {
    return (this.data as DashboardOperatorLoadStatisticModel)?.averageLoad;
  }

  get averageLoadValue(): number {
    return this.averageLoad?.value ?? 0;
  }

  get averageLoadPercentage(): number {
    return this.averageLoad?.percentage ?? 0;
  }

  get difference(): number {
    return (this.data as DashboardOperatorLoadStatisticModel)?.averageLoad?.trend ?? 0;
  }
}
